import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import Reveal from '../components/common/Reveal';
import { SectionHeader, Card, Tag } from '../components/ui';

export default function NewsPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get('/news').then(r => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <div style={{ padding: '120px 40px 40px', textAlign: 'center', background: 'linear-gradient(160deg,var(--cream),var(--soft-orange))' }}>
        <SectionHeader title="News &" accent="Events" sub="All the latest happenings at Wijjdan" />
      </div>
      <section style={{ padding: '40px 40px 80px', maxWidth: 800, margin: '0 auto' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          {items.map((n, i) => (
            <Reveal key={n.id} delay={i * .08}>
              <Card style={{ padding: 24, display: 'flex', gap: 16, alignItems: 'flex-start' }}>
                <div style={{ fontSize: 36, flexShrink: 0 }}>{n.emoji}</div>
                <div>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 6, flexWrap: 'wrap' }}>
                    <Tag type={n.type === 'Event' ? 'event' : undefined}>{n.type}</Tag>
                    <span style={{ fontSize: 12, color: '#999' }}>{n.event_date}</span>
                  </div>
                  <h4 className="serif" style={{ fontSize: '1.15rem', marginBottom: 4 }}>{n.title}</h4>
                  <p style={{ fontSize: 13, color: 'var(--brown)', fontWeight: 300 }}>{n.description}</p>
                </div>
              </Card>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
